import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Divider,
  Stack,
  Grid
} from "@mui/material";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";
// import { useNavigate } from "react-router-dom";
// import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import {
  callAPI,
  clearRequest,
  Method
} from "../../../commonFunctions/CommonFunctions";
import WSSelectField from "../../../Components/Select/WSSelect";

interface Props {
  customerId: string;
  customerName: string;
  availablePoints: number;
  // maxRedeemablePoints: number;
  // valuePerPoint: number; // ₹ per point
  orderTotal: number;
  redeemPoints: number;
  setRedeemPoints: (points: number) => void;  
}

// /api/loyalty/redeem
const PointsRedemption: React.FC<Props> = ({
  availablePoints,
  // maxRedeemablePoints,
  // valuePerPoint,
  orderTotal,
  // onConfirm,
  customerId,
  customerName,
  redeemPoints,
  setRedeemPoints
}) => {
  const { control, register, handleSubmit } = useForm();
  // const navigate = useNavigate();
  // const { showMessage } = useSnackbar();
  const [discount, setDiscount] = useState<number>(0);
  const [finalAmount, setFinalAmount] = useState<number>(orderTotal);
  const [applied, setApplied] = useState<boolean>(false);

  const handleApply = () => {
    if (redeemPoints <= 0 || redeemPoints > availablePoints) {
      return;
    }

    const validPoints = Math.min(
      redeemPoints,
      availablePoints
      // maxRedeemablePoints
    );

    // const calculatedDiscount = validPoints * valuePerPoint;
    const updatedFinal = Math.max(orderTotal - validPoints, 0);

    setRedeemPoints(validPoints);
    setDiscount(validPoints);
    setFinalAmount(updatedFinal);
    setApplied(true);
  };

  const handleRemove = () => {
    // setRedeemPoints(0);
    setDiscount(0);
    setFinalAmount(orderTotal);
    setApplied(false);
  };


  return (
    <Box
      p={3}
      border={1}
      borderRadius={2}
      borderColor="grey.300"
      maxWidth={"100%"}
      mt={3}
    >
      <Typography variant="h6" gutterBottom>
        Loyalty Points Redemption
      </Typography>

      <Stack spacing={2} mb={2}>
        <Typography>
          Current Points Balance: <b>{availablePoints}</b>
        </Typography>
        <Typography>
          Points to Redeem: <b>{availablePoints}</b>
        </Typography>
        {/* <Typography>
          Max Redeemable Points: <b>{maxRedeemablePoints}</b>
        </Typography> */}
        {/* <Typography>
          Value Per Point: <b>₹{valuePerPoint.toFixed(2)}</b>
        </Typography> */}

        {/* <TextField
          type="number"
          label="Points to Redeem"
          value={redeemPoints}
          onChange={(e) => setRedeemPoints(Number(e.target.value))}
          disabled={applied}
          inputProps={{ min: 0 }}
        /> */}

        <Grid item xs={12} sm={6} mb={2}>
          <WSTextField
            id="customerId"
            name="customerId"
            label="Customer"
            defaultValue={customerName}
            control={control}
            disabled
          />
        </Grid>

        {/* <Grid item sx={{ mb: 2 }}>
          <WSTextField
            id="redeemPoints"
            label="Points to Redeem"
            control={control}
            type={TextType.Number}
            defaultValue={availablePoints}
            disabled
            {...register("redeemPoints", {
              onChange: (e: any) => setRedeemPoints(Number(e.target.value)),
              required: "Redeem Points is required",
              validate: (value: any) => {
                if (value <= 0) return "Points must be greater than 0";
                if (value > availablePoints) return "Insufficient points";
                return true;
              }
            })}
          />
        </Grid> */}

        <Divider />

        <Typography>Discount Value: ₹{discount.toFixed(2)}</Typography>
        <Typography>
          Final Amount After Discount: ₹{finalAmount.toFixed(2)}
        </Typography>

        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleApply}
            disabled={
              applied || redeemPoints <= 0 || redeemPoints > availablePoints
            }
          >
            Apply Points
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            onClick={handleRemove}
            disabled={!applied}
          >
            Remove Points
          </Button>
        </Stack>

        {/* <Button
          variant="contained"
          color="success"
          onClick={() => onConfirm(finalAmount, redeemPoints)}
          disabled={!applied}
        >
          Confirm Order
        </Button> */}
      </Stack>
    </Box>
  );
};

export default PointsRedemption;
